import React from "react";
import { Panel, StatusBadge } from "../../components/ui/dashboard";

const rows = [
  { lr: "TT-2026-00180", receiver: "Metro Retail", status: "pending" },
  { lr: "TT-2026-00181", receiver: "Khandelwal Foods", status: "in_transit" },
  { lr: "TT-2026-00182", receiver: "RR Traders", status: "delivered" },
];

const MyConsignments: React.FC = () => {
  return (
    <div className="p-4 md:p-6">
      <Panel title="My Consignments" subtitle="Filter by status and download LR">
        <div className="mb-3 flex gap-2">
          <button className="px-2 py-1 rounded-lg text-xs bg-slate-900 text-white">All</button>
          <button className="px-2 py-1 rounded-lg text-xs bg-slate-100 text-slate-700">Pending</button>
          <button className="px-2 py-1 rounded-lg text-xs bg-slate-100 text-slate-700">In Transit</button>
          <button className="px-2 py-1 rounded-lg text-xs bg-slate-100 text-slate-700">Delivered</button>
        </div>
        <div className="space-y-2">
          {rows.map((row) => (
            <div key={row.lr} className="rounded-xl border border-slate-100 p-3 flex items-center justify-between">
              <div>
                <p className="text-sm font-semibold text-slate-900">{row.lr}</p>
                <p className="text-xs text-slate-500">Receiver: {row.receiver}</p>
              </div>
              <div className="flex items-center gap-2">
                <StatusBadge
                  label={row.status}
                  tone={row.status === "delivered" ? "success" : row.status === "in_transit" ? "info" : "warning"}
                />
                <button className="text-xs px-2 py-1 rounded-md bg-slate-100 text-slate-700">Download LR</button>
              </div>
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
};

export default MyConsignments;